import {en} from './en.js';
import {getNewStructure} from './transformOldTranslation.js';
import convertLocale from '../i18n/convertLocale.js';
import presentText from '../utils/presentText.js';

/**
 * @param prefix
 * @param phrase
 * @param translation
 * @param variables
 * @param logging
 * @param skipEmpty
 * @param campaignId
 * @param useEmailTag
 * @returns {string}
 */
export default function i18n({
  prefix = '',
  phrase = '',
  translation,
  variables = {},
  logging = false,
  skipEmpty = false,
  campaignId = '',
  useEmailTag = false
}) {
  if (!phrase) return '';
  if (prefix === 'Campaign') {
    translation = translation?.['Campaign'];
  }
  const initString = (() => {
    const phrases = (() => {
      if (prefix === 'FAQs') return [...prefix.split('.'), phrase].filter(Boolean);
      if (prefix === 'Campaign' && campaignId) return [campaignId, phrase].filter(Boolean);
      return [
        ...prefix.split('.'),
        ...(phrase.split('.')[phrase.split('.').length - 1] ? phrase.split('.') : [phrase])
      ].filter(Boolean);
    })();
    const keyPhrase = phrases.pop();
    const keyDict = phrases.reduce((prev, current) => prev?.[current] || {}, translation);
    if (keyDict.hasOwnProperty(keyPhrase)) return keyDict[keyPhrase] || '';
    if (skipEmpty) {
      if (logging) console.log(`missing i18n:`, `'${prefix}'.'${phrase}'`);
      return '';
    }

    const newTran = getNewStructure(translation, en);
    return i18n({
      prefix,
      phrase,
      translation: newTran,
      variables,
      logging,
      skipEmpty: true,
      campaignId
    });
  })();

  return presentText({text: initString, variables, useEmailTag});
}

/**
 * @param phrase
 * @param translation
 * @param variables
 * @param prefix
 * @returns {string}
 */
export const i18nPage = ({phrase, translation, variables, prefix = 'FAQ page'}) => {
  return i18n({prefix, phrase, translation: convertTranslation(translation), variables});
};

/**
 * @param phrase
 * @param translation
 * @param variables
 * @param isShowNavigation
 * @param useEmailTag
 * @returns {string}
 */
export const i18nWidget = ({
  phrase,
  translation,
  variables,
  useEmailTag,
  prefix = 'Show Navigation'
}) => {
  return i18n({
    prefix,
    phrase,
    translation: convertTranslation(translation),
    variables,
    useEmailTag
  });
};

/**
 * @param campaignId
 * @param phrase
 * @param translation
 * @param variables
 * @param prefix
 * @returns {string}
 */
export const i18nCampaign = ({campaignId, phrase, translation, variables, prefix = 'Campaign'}) => {
  return i18n({
    prefix,
    phrase,
    translation: convertTranslation(translation),
    variables,
    campaignId
  });
};

/**
 * @param translation
 * @returns {*}
 */
const convertTranslation = translation => {
  if (!translation) return {};
  const locale = convertLocale();
  const {
    primaryLanguage,
    [primaryLanguage]: primaryTranslation,
    [locale]: localeTranslation
  } = translation;

  if (!primaryLanguage) {
    return translation; // legacy translation
  }
  // translation corresponding to store locale or default locale
  return localeTranslation || primaryTranslation || {};
};
